/* =========================================================
   Pressden Pet Co. PDP Sections — Shared Behavior
   Loaded once; works across any number of these sections
   on the page by scoping every query to data-section-id.
   ========================================================= */
(function () {
  'use strict';

  // This file is <script src>'d from several sections (Hero, Quick-add, FAQ,
  // Email capture, Video). On a page using more than one, the browser executes
  // it once PER <script> tag — so everything below used to run multiple times
  // (duplicate click handlers, and on Hero/Quick-add, duplicate cart/add.js
  // calls per click). This guard makes every re-inclusion after the first a
  // no-op. Long-term, move the single <script src="pressden.js"> tag into
  // theme.liquid and remove it from the individual section files.
  if (window.__pdInitialized) return;
  window.__pdInitialized = true;

  function toast(msg) {
    var el = document.querySelector('[data-pd-toast]');
    if (!el) return;
    el.querySelector('[data-pd-toast-msg]').textContent = msg;
    el.classList.add('pd-show');
    clearTimeout(el._pdTimer);
    el._pdTimer = setTimeout(function () { el.classList.remove('pd-show'); }, 2200);
  }

  /* ---------------- Hero variant picker + add to cart ---------------- */
  function initHero(root) {
    var dataEl = root.querySelector('[data-pd-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selected = {};
    var optionInputs = root.querySelectorAll('[data-pd-option]');
    var idInput = root.querySelector('[data-pd-variant-id]');
    var priceNow = root.querySelector('[data-pd-price-now]');
    var priceWas = root.querySelector('[data-pd-price-was]');
    var atcBtn = root.querySelector('[data-pd-atc]');
    var atcLabel = root.querySelector('[data-pd-atc-label]');

    function fmtMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function currentSelections() {
      var vals = [];
      root.querySelectorAll('[data-pd-option-group]').forEach(function (group) {
        var active = group.querySelector('.pd-selected');
        vals.push(active ? active.getAttribute('data-pd-value') : null);
      });
      return vals;
    }

    function findVariant() {
      var vals = currentSelections();
      return product.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return vals.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = fmtMoney(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = fmtMoney(variant.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (atcBtn) atcBtn.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      // update main image if variant has a featured image
      if (variant.featured_image) {
        var main = root.querySelector('[data-pd-gallery-main]');
        if (main) {
          var img = main.querySelector('img');
          if (img) img.src = variant.featured_image.src;
        }
      }
      updateStickyBar(root, variant);
    }

    root.querySelectorAll('[data-pd-option-group] [data-pd-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-pd-option-group]');
        group.querySelectorAll('[data-pd-value]').forEach(function (b) { b.classList.remove('pd-selected'); });
        btn.classList.add('pd-selected');
        var label = group.querySelector('[data-pd-selected-label]');
        if (label) label.textContent = btn.getAttribute('data-pd-value');
        updateUI();
      });
    });

    // Quantity stepper
    var qtyInput = root.querySelector('[data-pd-qty-hidden]');
    var qtyMinus = root.querySelector('[data-pd-qty-minus]');
    var qtyPlus = root.querySelector('[data-pd-qty-plus]');
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      clearTierSelection();
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      qtyInput.value = Math.min(99, parseInt(qtyInput.value || '1', 10) + 1);
      clearTierSelection();
    });

    // Bundle tiers — clicking a tier sets the quantity to that tier's pack size
    function clearTierSelection() {
      root.querySelectorAll('[data-pd-tier]').forEach(function (t) { t.classList.remove('pd-selected'); });
    }
    root.querySelectorAll('[data-pd-tier]').forEach(function (tier) {
      tier.addEventListener('click', function () {
        root.querySelectorAll('[data-pd-tier]').forEach(function (t) { t.classList.remove('pd-selected'); });
        tier.classList.add('pd-selected');
        var qty = parseInt(tier.getAttribute('data-pd-tier-qty') || '1', 10);
        if (qtyInput) qtyInput.value = qty;
      });
    });

    // Add to cart via Shopify AJAX Cart API — includes any checked order-bump products
    var form = root.querySelector('.pd-cart-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcBtn && atcBtn.disabled) return; // already submitting — ignore double clicks
        var mainVariantId = idInput ? idInput.value : null;
        var mainQty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;

        if (!mainVariantId) {
          toast('Please choose a color and size first');
          console.error('[Pressden] No variant selected — check that a color/size combination matches a real variant.');
          return;
        }

        if (atcBtn) atcBtn.disabled = true;

        var items = [{ id: mainVariantId, quantity: mainQty }];

        root.querySelectorAll('[data-pd-bump-checkbox]:checked').forEach(function (cb) {
          var bumpId = cb.getAttribute('data-pd-bump-variant-id');
          if (bumpId) items.push({ id: bumpId, quantity: 1 });
        });

        fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok || result.data.status) {
              var msg = result.data.description || result.data.message || 'Item unavailable';
              toast(msg);
              console.error('[Pressden] cart/add.js error:', result.data);
              if (atcBtn) atcBtn.disabled = false;
              return;
            }
            toast('Added to cart — taking you there...');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            setTimeout(function () {
              window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
            }, 700);
          })
          .catch(function (err) {
            toast("Couldn't add to cart — please try again");
            console.error('[Pressden] Network/JS error adding to cart:', err);
            if (atcBtn) atcBtn.disabled = false;
          });
      });
    }

    // Gallery thumbnails
    root.querySelectorAll('[data-pd-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-pd-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var main = root.querySelector('[data-pd-gallery-main] img');
        var fullSrc = thumb.getAttribute('data-pd-full');
        if (main && fullSrc) main.src = fullSrc;
      });
    });

    updateUI();
  }

  /* ---------------- Sticky add-to-cart bar ---------------- */
  var stickyBar = null;
  function updateStickyBar(heroRoot, variant) {
    if (!stickyBar) stickyBar = document.querySelector('[data-pd-sticky]');
    if (!stickyBar) return;
    var title = stickyBar.querySelector('[data-pd-sticky-sub]');
    if (title && variant) {
      title.textContent = '$' + (variant.price / 100).toFixed(2);
    }
    var stickyBtn = stickyBar.querySelector('[data-pd-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.onclick = function () {
        var form = heroRoot.querySelector('.pd-cart-form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      };
    }
  }

  function initStickyObserver() {
    var hero = document.querySelector('[data-pd-hero-anchor]');
    var bar = document.querySelector('[data-pd-sticky]');
    if (!hero || !bar) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) bar.classList.add('pd-show');
        else bar.classList.remove('pd-show');
      });
    }, { threshold: 0 });
    obs.observe(hero);
  }

  /* ---------------- Video modal (shared across gallery instances) ---------------- */
  function initVideoTriggers() {
    var modal = document.querySelector('[data-pd-video-modal]');
    if (!modal) return;
    var inner = modal.querySelector('[data-pd-video-modal-inner]');

    function embedFor(url) {
      if (!url) return '';
      if (url.indexOf('youtube.com') > -1 || url.indexOf('youtu.be') > -1) {
        var id = (url.match(/(?:v=|youtu\.be\/)([\w-]+)/) || [])[1];
        return '<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      }
      if (url.indexOf('vimeo.com') > -1) {
        var vid = (url.match(/vimeo\.com\/(\d+)/) || [])[1];
        return '<iframe src="https://player.vimeo.com/video/' + vid + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      }
      return '<video src="' + url + '" controls autoplay playsinline></video>';
    }

    document.querySelectorAll('[data-pd-video-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var url = trigger.getAttribute('data-pd-video-url');
        if (!url) {
          inner.innerHTML = '<div style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;color:rgba(255,255,255,.7);font-size:13.5px;text-align:center;padding:20px;font-family:sans-serif;">No video added yet — add one in the theme editor.</div>';
        } else {
          inner.innerHTML = embedFor(url);
        }
        modal.classList.add('pd-open');
        document.body.style.overflow = 'hidden';
      });
    });

    function close() {
      modal.classList.remove('pd-open');
      inner.innerHTML = '';
      document.body.style.overflow = '';
    }
    modal.querySelectorAll('[data-pd-video-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- Urgency countdown timer ---------------- */
  function initCountdown(root) {
    var el = root.querySelector('[data-pd-countdown]');
    if (!el) return;
    var minutes = parseFloat(el.getAttribute('data-pd-countdown-minutes') || '15');
    var storageKey = 'pd_countdown_' + (root.id || 'default');
    var endTime = sessionStorage.getItem(storageKey);
    if (!endTime) {
      endTime = Date.now() + minutes * 60000;
      sessionStorage.setItem(storageKey, endTime);
    } else {
      endTime = parseInt(endTime, 10);
    }
    function tick() {
      var remaining = Math.max(0, endTime - Date.now());
      var m = Math.floor(remaining / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (remaining <= 0) {
        sessionStorage.removeItem(storageKey);
        endTime = Date.now() + minutes * 60000;
        sessionStorage.setItem(storageKey, endTime);
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------------- Quick-add bar (standalone repeatable section) ---------------- */
  function initQuickAdd(root) {
    var dataEl = root.querySelector('[data-pd-quickadd-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var select = root.querySelector('[data-pd-quickadd-select]');
    var priceEl = root.querySelector('[data-pd-quickadd-price]');
    var wasEl = root.querySelector('[data-pd-quickadd-was]');
    var btn = root.querySelector('[data-pd-quickadd-btn]');

    function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }

    function currentVariant() {
      if (!select) return product[0];
      return product.find(function (v) { return String(v.id) === select.value; }) || product[0];
    }

    function updatePrice() {
      var v = currentVariant();
      if (!v) return;
      if (priceEl) priceEl.textContent = fmtMoney(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.textContent = fmtMoney(v.compare_at_price);
          wasEl.style.display = '';
        } else {
          wasEl.style.display = 'none';
        }
      }
    }
    if (select) select.addEventListener('change', updatePrice);
    updatePrice();

    if (btn) {
      btn.addEventListener('click', function () {
        var v = currentVariant();
        if (!v) return;
        fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) { toast(data.description || "Couldn't add that to your cart"); return; }
            toast('Added to cart — taking you there...');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart';
            }, 700);
          })
          .catch(function () { toast("Couldn't add to cart — please try again"); });
      });
    }
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq(root) {
    root.querySelectorAll('[data-pd-faq-q]').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('[data-pd-faq-item]');
        var wasOpen = item.classList.contains('pd-open');
        root.querySelectorAll('[data-pd-faq-item]').forEach(function (i) { i.classList.remove('pd-open'); });
        if (!wasOpen) item.classList.add('pd-open');
      });
    });
  }

  /* ---------------- Email capture ----------------
     The form is a real Shopify `customer` form (see the section file) that posts
     to /contact and creates/tags the customer server-side. This handler submits
     it via fetch so the page doesn't reload, falling back to a normal submit
     (full page reload, still 100% functional) if the request fails. */
  function initEmailForm(root) {
    var form = root.querySelector('.pd-email-form-shopify');
    if (!form) return;
    var code = root.getAttribute('data-pd-discount-code') || '';

    function showSuccess() {
      var wrap = root.querySelector('[data-pd-email-form-wrap]');
      var success = root.querySelector('[data-pd-email-success]');
      var codeEl = root.querySelector('[data-pd-email-code]');
      if (codeEl && code) codeEl.textContent = code;
      if (wrap) wrap.classList.add('pd-hide');
      if (success) success.classList.add('pd-show');
    }

    function handleSubmit(e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch(form.action, { method: 'POST', body: data })
        .then(showSuccess)
        .catch(function () {
          form.removeEventListener('submit', handleSubmit);
          form.submit();
        });
    }
    form.addEventListener('submit', handleSubmit);
  }

  /* ---------------- Safe runner ----------------
     Wraps every init call so a bug in ONE section (e.g. Hero) can never
     throw and silently prevent later sections (e.g. FAQ) from initializing.
     Each failure is isolated and logged to the console with a clear tag. */
  function safeRun(label, fn) {
    try { fn(); } catch (err) { console.error('[Pressden] ' + label + ' failed to init:', err); }
  }

  /* ---------------- Init everything on DOM ready ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pd-hero]').forEach(function (el) { safeRun('Hero', function () { initHero(el); }); });
    document.querySelectorAll('[data-pd-hero]').forEach(function (el) { safeRun('Countdown', function () { initCountdown(el); }); });
    document.querySelectorAll('[data-pd-quickadd]').forEach(function (el) { safeRun('Quick-add', function () { initQuickAdd(el); }); });
    document.querySelectorAll('[data-pd-faq]').forEach(function (el) { safeRun('FAQ', function () { initFaq(el); }); });
    document.querySelectorAll('[data-pd-email]').forEach(function (el) { safeRun('Email form', function () { initEmailForm(el); }); });
    safeRun('Video triggers', initVideoTriggers);
    safeRun('Sticky observer', initStickyObserver);
  });

  // Shopify theme editor: re-init when a section is added/re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el.querySelector('[data-pd-hero]')) {
      safeRun('Hero', function () { initHero(el.querySelector('[data-pd-hero]')); });
      safeRun('Countdown', function () { initCountdown(el.querySelector('[data-pd-hero]')); });
    }
    if (el.querySelector('[data-pd-quickadd]')) safeRun('Quick-add', function () { initQuickAdd(el.querySelector('[data-pd-quickadd]')); });
    if (el.querySelector('[data-pd-faq]')) safeRun('FAQ', function () { initFaq(el.querySelector('[data-pd-faq]')); });
    if (el.querySelector('[data-pd-email]')) safeRun('Email form', function () { initEmailForm(el.querySelector('[data-pd-email]')); });
    safeRun('Video triggers', initVideoTriggers);
    safeRun('Sticky observer', initStickyObserver);
  });
})();
